import { ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, Injectable, Injector } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class DomService {
	constructor(private componentFactoryResolver: ComponentFactoryResolver, private appRef: ApplicationRef, private injector: Injector) { }

	public appendComponentToBody(component: any): void {
		const domElement = this.getDomElement(component);
		if (!document.querySelector(domElement.tagName)) {
			document.body.appendChild(domElement);
		}
	}

	public prependComponentToBody(component: any): void {
		document.body.insertBefore(this.getDomElement(component), document.body.childNodes[0]);
	}

	private getDomElement(component: any): HTMLElement {
		// 1. Create a component reference from the component
		const componentRef = this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);

		// 2. Attach component to the appRef so that it's inside the ng component tree
		this.appRef.attachView(componentRef.hostView);

		// 3. Get DOM element from component
		return (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
	}
}
